export const tokens = {
    padding: 2,
    iconSize: 12,
    fontSize: 16,
    tooltip: {
        padding: 16,
        radius: 10,
    },
};
